/**
 * Hook de utilidad para scroll suave con offset para compensar el header sticky
 * Altura del header: 80px (h-20) + margen de seguridad = 100px total
 */

const HEADER_OFFSET = 100;

/**
 * Función para hacer scroll suave a una sección específica
 * @param {string} sectionId - ID del elemento al que hacer scroll (sin #)
 * @param {number} offset - Offset adicional (por defecto usa HEADER_OFFSET)
 */
export const scrollToSection = (sectionId, offset = HEADER_OFFSET) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({ 
      top: offsetPosition, 
      behavior: 'smooth' 
    });
  }
};

/**
 * Manejador de click para enlaces ancla
 * Previene el comportamiento por defecto y aplica scroll suave con offset
 * @param {Event} e - Evento del click
 * @param {number} offset - Offset opcional
 */
export const handleAnchorClick = (e, offset = HEADER_OFFSET) => {
  const href = e.currentTarget.getAttribute('href');
  if (href && href.startsWith('#')) {
    e.preventDefault();
    const sectionId = href.substring(1);
    scrollToSection(sectionId, offset);
  }
};

/**
 * Hook personalizado que retorna las funciones de scroll
 * @returns {Object} - Objeto con las funciones de scroll
 */
const useSmoothScroll = () => {
  return {
    scrollToSection,
    handleAnchorClick,
    HEADER_OFFSET
  };
};

export default useSmoothScroll;
